

/**
 * @return {void}
 */
module.exports = function whitepaperFormFields() {

}